import type {LegalDoc} from "./common";
import {CONSENT_MAILING_DOC} from "./consentMailing";
import {CONSENT_PD_DOC} from "./consentPd";
import {FUNCTIONAL_CHARACTERISTICS_DOC} from "./functionalCharacteristics";
import {INSTALLATION_OPERATION_DOC} from "./installationOperation";
import {OFFER_DOC} from "./offer";
import {PRIVACY_DOC} from "./privacy";
import {TERMS_DOC} from "./terms";
import {USER_GUIDE_DOC} from "./userGuide";

export {CONTACT, SERVICE, type LegalDoc, type LegalSection} from "./common";

/** Реестр юридических документов: ключ — тот, что приходит в роут. */
export const DOCS = {
    privacy: PRIVACY_DOC,
    terms: TERMS_DOC,
    offer: OFFER_DOC,
    consentPd: CONSENT_PD_DOC,
    consentMailing: CONSENT_MAILING_DOC,
    functionalCharacteristics: FUNCTIONAL_CHARACTERISTICS_DOC,
    installationOperation: INSTALLATION_OPERATION_DOC,
    userGuide: USER_GUIDE_DOC,
} satisfies Record<string, LegalDoc>;

export type DocKey = keyof typeof DOCS;
